import { render, staticRenderFns } from "./loglist.vue?vue&type=template&id=52a1a821&scoped=true&"
import script from "./loglist.vue?vue&type=script&lang=js&"
export * from "./loglist.vue?vue&type=script&lang=js&"
import style0 from "./loglist.vue?vue&type=style&index=0&id=52a1a821&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a1a821",
  null
  
)

export default component.exports